
import {
  backgroundCover,
  wrapperStyles,
  columnsWrapperStyles,
  singleColumnStyles,
  singleColumnTabletStyles
} from 'components/Templates/commonStyles/DefaultCssValues';

import {
  sectionWrapperStyles,
  sectionWrapperTabletStyles,
  sectionWrapperMobileStyles,
  wrapperWithMarginStyles,
  wrapperWithMarginTabletStyles,
  typoHeader,
  typoHeaderMobile,
  typoParagraph
} from 'components/Templates/styles/Red/commonObjectsStyles';

import textImg from 'components/Templates/styles/Red/assets/JPG/textimage.jpg'; //Need another JPG

/* eslint-disable */
export default {
  wrapper: {
    '0': {
      ...wrapperStyles,
      ...sectionWrapperStyles,
      'background-color' : '#FFFFFF'
    },
    '76_8' : {
      ...sectionWrapperTabletStyles
    },
    '37_5' : {
      ...sectionWrapperMobileStyles
    }
  },
  wrapperWithMargin: {
    '0': {
      ...wrapperWithMarginStyles
    },
    '76_8' : {
      ...wrapperWithMarginTabletStyles
    }
  },
  columnsWrapper: {
    '0': {
      ...columnsWrapperStyles,
    'margin-bottom': '2rem'
    }
  },
  columnText: {
    '0': {
      ...singleColumnStyles,
      'padding-right': '5rem',
      'padding-left': '8rem'
    },
    '76_8': {
      ...singleColumnTabletStyles,
      'padding-right': '0',
      'margin-top': '4rem',
      'padding-left': '0'
    }
  },
  columnImage: {
    '0': {
      ...singleColumnStyles,
      ...backgroundCover,
      'background-image': `url(${textImg})`,
      'background-position': 'center',
      'min-height': '35rem',
    },
    '76_8': {
      ...singleColumnTabletStyles
    }
  },
  sectionTitle: {
    '0': {
      ...typoHeader,
    'margin-bottom' : '5rem'
    },
    '76_8' : {
      ...typoHeaderMobile,
      'margin-bottom' : '2rem'
    },
  },
  paragraph: {
    '0': {
      ...typoParagraph,
      'margin-bottom' : '6rem'
    },
    '76_8' : {
      'margin-bottom' : '3rem'
    }
  },
}
